import { getJwtToken } from "@infinitaslearning/il.authentication.avatar"
import jwtDecode from "jwt-decode"
import { useEffect, useState } from "react"
import type { JwtToken } from "./../redux/user/user.types"

export interface IUseJwtToken {
  roles: string[] | undefined
  userEmail: string | undefined
  loading: boolean
}

export function useUserObject(): IUseJwtToken {
  const [userEmail, setUserEmail] = useState<string>()
  const [roles, setRoles] = useState<string[]>([])
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    const fetchJwt = async () => {
      const token = await getJwtToken()

      if (!token) return
      const { role, email }: JwtToken = jwtDecode(token)
      setRoles(typeof role === "string" ? [role] : role)
      setUserEmail(email)
    }

    fetchJwt().finally(() => setLoading(false))
  }, [])

  return { roles, userEmail, loading }
}
